import { useFormContext } from "react-hook-form"
import { FieldError } from "@motley/design"
import getOwnMessage from "./getOwnMessage"

type Props = {
  path?: string
  className?: string
}

export default function FormError({
  path = "root.formError",
  className = "mb-4",
}: Props) {
  const {
    formState: { errors },
  } = useFormContext()

  // Read both unconditionally: conditional access breaks RHF's formState proxy
  // subscription, and the message stops re-rendering.
  const rootMessage = errors.root?.formError?.message
  const pathMessage = getOwnMessage(errors, path)
  const message = pathMessage ?? rootMessage

  return !message ? null : (
    <FieldError className={className}>{message}</FieldError>
  )
}
